export function isValueDisabled(value: any) {
  return ['undefined', 'null', '0', 'false', 'no', 'n', '', '&nbsp;'].includes(
    String(value).trim().toLowerCase()
  )
}
